import { Controller } from "@hotwired/stimulus"

// Paperclip attach for the chat composer: pick a file, show its name, allow removal.
// The file rides the multipart form submit as `file_data`; the controller attaches it
// to the message and BuildLane feeds it to the report planner. No chat-specific coupling.
export default class extends Controller {
  static targets = ["input", "chip", "name"]

  pick() {
    this.inputTarget.click()
  }

  changed() {
    const file = this.inputTarget.files[0]
    if (!file) return this.remove()
    if (this.hasNameTarget) this.nameTarget.textContent = file.name
    if (this.hasChipTarget) this.chipTarget.classList.remove("hidden")
  }

  remove() {
    this.inputTarget.value = ""
    if (this.hasChipTarget) this.chipTarget.classList.add("hidden")
  }
}
